import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"axis-select","item-text":"nome","item-name":"eixoId","item-value":"eixoId","items":_vm.axis,"label":"Grupo de Solução","placeholder":"Grupo de Solução","clearable":""},model:{value:(_vm.filter.eixoId),callback:function ($$v) {_vm.$set(_vm.filter, "eixoId", $$v)},expression:"filter.eixoId"}},[_c('template',{slot:"no-data"},[_vm._v("\n    Nenhum Grupo de Solução retornado\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }